export default {
  shopDomain: null
};
